/**
 * fetch wrapper that returns to sign in when the session is no longer accepted,
 * rather than letting a raw 401 surface on whichever screen made the call.
 *
 * To adopt: replace `fetch(...)` with `apiFetch(...)`. Same signature.
 */

const SESSION_KEYS = ['token', 'authToken', 'refreshToken', 'user', 'persist:root'];

const LOGIN_PATH = '/login';

/** True once a redirect is under way, so several failing calls trigger one. */
let redirecting = false;

export async function apiFetch(input: RequestInfo, init?: RequestInit): Promise<Response> {
  const response = await fetch(input, init);

  // A 401 on the sign-in screen means bad credentials, not an expired session.
  if (
    (response.status === 401 || response.status === 403) &&
    window.location.pathname !== LOGIN_PATH &&
    !redirecting
  ) {
    redirecting = true;
    SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
    sessionStorage.clear();
    window.location.replace(`${LOGIN_PATH}?reason=expired`);
    throw new Error('Session expired');
  }

  return response;
}
